import { render, staticRenderFns } from "./ServerSeeds.vue?vue&type=template&id=76379e8e&"
import script from "./ServerSeeds.vue?vue&type=script&lang=js&"
export * from "./ServerSeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports